import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirmar Ação",
  message = "Tem certeza que deseja continuar?",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  type = "warning" // warning, danger, info
}) => {
  if (!isOpen) return null;

  const getIconAndColor = () => {
    switch (type) {
      case 'danger':
        return {
          icon: 'AlertTriangle',
          color: 'var(--color-destructive)',
          bgColor: 'bg-destructive/10',
          borderColor: 'border-destructive/20'
        };
      case 'info':
        return {
          icon: 'Info',
          color: 'var(--color-primary)',
          bgColor: 'bg-primary/10',
          borderColor: 'border-primary/20'
        };
      default: // warning
        return {
          icon: 'AlertCircle',
          color: 'var(--color-warning)',
          bgColor: 'bg-warning/10',
          borderColor: 'border-warning/20'
        };
    }
  };

  const { icon, color, bgColor, borderColor } = getIconAndColor();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg shadow-elevation-3 w-full max-w-md">
        {/* Header */}
        <div className="flex items-center space-x-3 p-6 border-b border-border">
          <div className={`w-10 h-10 ${bgColor} rounded-lg flex items-center justify-center`}>
            <Icon name={icon} size={20} color={color} />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">{title}</h2>
            <p className="text-sm text-muted-foreground">Esta ação não pode ser desfeita</p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-sm text-foreground leading-relaxed">
            {message}
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
          >
            {cancelText}
          </Button>
          <Button
            variant={type === 'danger' ? 'destructive' : 'default'}
            onClick={onConfirm}
            iconName={type === 'danger' ? 'Trash2' : 'Check'}
            iconPosition="left"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
